import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'action-status',
  templateUrl: 'action-status.component.html',
  styleUrls: ['action-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionStatusComponent {
  @Input() status: 'accept' | 'progress' | 'reject';
  @Input() titleText: string;
  @Input() translatedTitle: string;
  @Input() description: string;
  @Input() translatedDescription: string;
  @Input() buttonVisible: boolean;
  @Input() buttonTemplate: TemplateRef<HTMLElement>;
  @Input() buttonTplContext: Record<string, any>;
  @Input() icon: string;

  constructor(
    private readonly _router: Router,
  ) {
    this.status = 'accept';
    this.titleText = 'profile-common.message.success';
    this.buttonVisible = true;
  }

  public back() {
    if (this._router.routerState.snapshot.url.includes('/partner')) {
      this._router.navigate(['/partner', 'profile']);
    } else {
      this._router.navigate(['/profile']);
    }
  }
}

// как юзать
// <action-status *ngIf='условие когда показывать компонент'
// [title]='какой-то тайтл' [description]='какое-то описание' icon='иконочка в img/icons/state/'>
// </action-status>
